var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statement-content"},[_c('div',[_c('img',{attrs:{"src":"https://img.icons8.com/color/96/000000/bus.png","alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.info))]),_c('div',{staticClass:"fade-background"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }